module.exports = __webpack_public_path__ + "3cd92dd7fe2873b2b74472ab200577f5.png";